import { config } from "../../vue/helpers/domain-config";

const LOCAL_STORAGE_KEYS = {
  SELECTED_LANGUAGE: "selected-language",
};

export function getSelectedLanguage() {
  const storedLang = window.localStorage.getItem(LOCAL_STORAGE_KEYS.SELECTED_LANGUAGE)
  if(config.subdomain === "ca" && config.productName === "thevracademy"){
    return   storedLang || "fr"
  }
  return (
    storedLang || config.lang || "en"
  );
}

export function setSelectedLanguage(language) {
  window.localStorage.setItem(LOCAL_STORAGE_KEYS.SELECTED_LANGUAGE, language);
}
